module.exports = __webpack_public_path__ + "img/puntajeLN.98d4a5a0.jpg";